import React from 'react';
import { ArrowLeft, Shield } from 'lucide-react';

export default function TermsPage() {
  const year = new Date().getFullYear();

  return (
    <div className="App" style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem 4rem' }}>

        {/* Back */}
        <a href="/" className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-manrope font-600 text-sm mb-8 transition-colors" data-testid="terms-back">
          <ArrowLeft size={16} /> Torna al sito
        </a>

        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Shield size={28} className="text-gold" />
          <h1 className="font-playfair text-3xl sm:text-4xl font-bold text-white">Termini e Condizioni</h1>
        </div>
        <p className="text-gold font-manrope font-600 text-sm uppercase tracking-wider mb-10">Peschiera Club</p>

        <div className="space-y-8 text-gray-300 font-manrope text-base leading-relaxed">

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">1. Servizi offerti</h2>
            <p className="mb-2">Il sito consente la prenotazione di:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Tavoli</li>
              <li>Ingressi</li>
              <li>Liste</li>
              <li>Eventi privati e aziendali</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">2. Prenotazioni</h2>
            <p className="mb-2">Le prenotazioni sono:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Senza obbligo vincolante</li>
              <li>Senza pagamento online</li>
              <li>Soggette a disponibilit&agrave;</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">3. Prezzi</h2>
            <p>I prezzi possono variare in base all'evento e saranno comunicati direttamente dal locale.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">4. Pagamento</h2>
            <p>Il pagamento avviene esclusivamente presso il locale.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">5. Modifica e cancellazione</h2>
            <p className="mb-2">Le prenotazioni possono essere modificate o cancellate:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Telefonicamente</li>
              <li>Tramite il sito</li>
            </ul>
            <p className="mt-2">&Egrave; consigliato avvisare almeno 24 ore prima, ma non &egrave; obbligatorio.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">6. Limiti di et&agrave;</h2>
            <p className="mb-2">L'accesso agli eventi &egrave; generalmente riservato a:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Maggiori di 18 anni</li>
              <li>In alcuni casi maggiori di 16 anni</li>
            </ul>
            <p className="mt-2">Il locale si riserva il diritto di verificare l'et&agrave; tramite documento.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">7. Diritto di rifiuto</h2>
            <p className="mb-2">Il locale si riserva il diritto di:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Rifiutare l'ingresso</li>
              <li>Allontanare persone con comportamenti non adeguati</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">8. Norme di comportamento</h2>
            <p className="mb-2">All'interno del locale &egrave; richiesto:</p>
            <ul className="list-disc list-inside space-y-1 text-gray-400 pl-2">
              <li>Rispetto verso staff e altri clienti</li>
              <li>Comportamento civile e adeguato</li>
              <li>Divieto di atteggiamenti aggressivi o molesti</li>
              <li>Rispetto delle normative vigenti</li>
            </ul>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">9. Variazioni eventi</h2>
            <p>Il locale si riserva il diritto di modificare o annullare eventi per cause organizzative, tecniche o di forza maggiore. In tali casi, verr&agrave; fornita comunicazione tempestiva agli utenti.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">10. Responsabilit&agrave;</h2>
            <p>Il locale non &egrave; responsabile per eventuali disservizi dovuti a cause di forza maggiore.</p>
          </section>

          <section>
            <h2 className="font-playfair text-xl font-bold text-white mb-3">11. Legge applicabile</h2>
            <p>Le presenti condizioni sono regolate dalla legge italiana.<br />Foro competente: Biella.</p>
          </section>

          {/* Separator */}
          <div className="neon-line my-8" />

          <p className="text-gray-500 text-sm">Ultimo aggiornamento: 20 marzo {year}</p>
        </div>
      </div>
    </div>
  );
}
